import { render, staticRenderFns } from "./myDialog1.vue?vue&type=template&id=1149b273&scoped=true&"
import script from "./myDialog1.vue?vue&type=script&lang=js&"
export * from "./myDialog1.vue?vue&type=script&lang=js&"
import style0 from "./myDialog1.vue?vue&type=style&index=0&id=1149b273&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1149b273",
  null
  
)

export default component.exports